import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ScrollManager } from './components/ScrollManager';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
import { Home } from './pages/Home';
import { ServiceDetail } from './pages/ServiceDetail';
import { ServiceAreaPage } from './pages/ServiceAreaPage';
import { NotFound } from './pages/NotFound';
interface AppProps {
  /** Language the site loads in for first-time visitors. */
  defaultLanguage?: 'en' | 'es';
  /** Show the SEO blog / education section on the home page. */
  showBlog?: boolean;
}
export function App({
  defaultLanguage = 'en',
  showBlog = true
}: AppProps) {
  return <LanguageProvider initialLang={defaultLanguage} data-id="element-0" data-mp="28t4lee0esat0">
      <BrowserRouter data-id="element-1" data-mp="23vcikoy874a1">
        <ScrollManager data-id="element-2" data-mp="23w4fc33k781w" />
        <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-3" data-mp="23ujl6el5pr4k">
          <Navbar data-id="element-4" data-mp="3ikh5c1uvgeva" />
          <main className="flex-1" data-id="element-5" data-mp="3iiwasc8k4vxf">
            <Routes data-id="element-6" data-mp="3ihv1ac76whht">
              <Route path="/" element={<Home showBlog={showBlog} data-id="element-8" data-mp="3mkrc3gqhn9b7" />} data-id="element-7" data-mp="3mlawd43m29se" />
              <Route path="/services/:slug" element={<ServiceDetail data-id="element-10" data-mp="3rbr9so7flver" />} data-id="element-9" data-mp="3mjgannkimdn9" />
              <Route path="/service-areas/:slug" element={<ServiceAreaPage data-id="element-12" data-mp="5yjsutqtdfe" />} data-id="element-11" data-mp="3rdkgu4lyihna" />
              <Route path="*" element={<NotFound data-id="element-14" data-mp="5ggje8nxyxz" />} data-id="element-13" data-mp="682rygdekbl" />
            </Routes>
          </main>
          <Footer data-id="element-15" data-mp="2zlv66six0xu0" />
          <FloatingActions data-id="element-16" data-mp="2zmeowbge3q93" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}